module.exports = __webpack_public_path__ + "static/media/HCMM046.4d8fde5f.jpg";